import type { Task } from "@coworker/types/lib/tasks/base";
import { compareDate } from "@coworker/apprestructured/src/shared/helpers/date.helper";

type TaskCreatedAt = Pick<Task, "created_at">;
export function createdAtAscending(
  first: Partial<TaskCreatedAt>,
  second: Partial<TaskCreatedAt>
) {
  if (first.created_at && second.created_at) {
    return compareDate(new Date(first.created_at), new Date(second.created_at));
  } else if (!first.created_at && second.created_at) {
    return 1;
  } else if (first.created_at && !second.created_at) {
    return -1;
  } else {
    return 0;
  }
}
